import React, { memo, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import { WpIcon } from 'Wpds/components/icon';
import ExpandNavbarContext from 'Shared/contexts/ExpandNavbarContext';

import { useTooltip } from 'Wpds/components/tooltip/useTooltip';
import WpTooltipOverlay from 'Wpds/components/tooltip/WpTooltipOverlay';

type Props = {
  badge?: React.ReactNode;
  to: string;
  exact?: boolean;
  label: string;
  iconClassName: string;
  onClick?: Function;
  isLocked?: boolean;
  lockedDescription?: string;
};

function SideNavigationLink({
  to,
  badge,
  exact = false,
  label,
  iconClassName,
  onClick,
  isLocked,
  lockedDescription,
}: Props) {
  const isExpanded = useContext(ExpandNavbarContext);

  const tooltip = useTooltip({ placement: 'right' });

  return (
    <>
      <li className="nav-item" ref={tooltip.targetRef}>
        <NavLink
          to={to}
          exact={exact}
          className="nav-link d-flex justify-content-center pr-1"
          activeClassName="active"
          onClick={onClick}
        >
          <div className={cn({ 'd-inline': isExpanded, 'text-center': !isExpanded })}>
            <span
              className={cn(`side-navigation-icon`, {
                'mx-auto': !isExpanded,
              })}
            >
              <WpIcon name={iconClassName} />
            </span>
          </div>
          {isExpanded && <div className="d-inline">{label}</div>}
          {isExpanded && !isLocked && <div className="d-inline ml-auto">{badge}</div>}
          {isExpanded && isLocked && (
            <div className="d-inline ml-auto mr-1">
              <WpIcon name="lock-alt" />
            </div>
          )}
        </NavLink>
      </li>
      {!isExpanded && <WpTooltipOverlay context={tooltip}>{label}</WpTooltipOverlay>}
      {isExpanded && isLocked && lockedDescription && (
        <WpTooltipOverlay context={tooltip}>{lockedDescription}</WpTooltipOverlay>
      )}
    </>
  );
}

export default memo(SideNavigationLink);
